import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { nameregex, priceRegex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { getpropertyType } from "../store/slices/propertyType";
import { getPlaceList } from "../store/slices/places";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { GrUploadOption } from "react-icons/gr";
import { getAmenityList } from "../store/slices/amenity";
import { editHotel, gethotelList } from "../store/slices/hotelAdmin";

const EditProperty = () => {
  let user = JSON.parse(localStorage.getItem("users"));

  const token = user.data.accessToken;
  const editor = useRef(null);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [propertyType, setpropertyType] = useState("");
  const [starRating, setstarRating] = useState("");
  const [locality, setLocality] = useState("");
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [standardPrice, setstandardPrice] = useState("");
  const [availableRooms, setavailableRooms] = useState("");
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [contact, setContact] = useState({
    name: "",
    email: "",
    mobile: "",
    website: "",
  });

  const [bookingPolicy, setbookingPolicy] = useState("");
  const [propertytypeList, setpropertytypeList] = useState([]);
  const [placeList, setplaceList] = useState([]);
  const [amenityList, setamenityList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };

  useEffect(() => {
    const fetPropertyDetails = async () => {
      try {
        const data = await dispatch(gethotelList({ id })).unwrap();
        const hotelDatas = data?.hotelData[0];
        setName(hotelDatas.name);
        setpropertyType(hotelDatas.propertyType._id);
        setavailableRooms(hotelDatas.availableRooms);
        setstandardPrice(hotelDatas.standardPrice);
        setstarRating(hotelDatas.starRating);
        setbookingPolicy(hotelDatas.bookingPolicy);
        setDescription(hotelDatas.description);
        setImages(hotelDatas.images);
        setLocality(hotelDatas.locality?._id || "");
        setContact(hotelDatas.contact);
        const fetchedAmenities = hotelDatas?.amenities || [];
        setSelectedAmenities(fetchedAmenities.map((amenity) => amenity._id));
      } catch (error) {
        console.error("Error fetching package details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetPropertyDetails();
  }, [dispatch, id]);

  const handleAmenityChange = (amenityId) => {
    setSelectedAmenities((prev) => {
      if (prev.includes(amenityId)) {
        // Remove if already selected
        return prev.filter((id) => id !== amenityId);
      } else {
        // Add if not selected
        return [...prev, amenityId];
      }
    });
  };

  const validateAddressField = (field, value) => {
    switch (field) {
      case "address":
        return value.trim() === "" ? "Please enter address" : "";
      case "zipCode":
        return value === ""
          ? "Please enter pincode"
          : !/^\d{6}$/.test(value)
          ? "Please enter a valid pincode"
          : "";
      case "city":
        return value.trim() === "" ? "Please enter city name" : "";
      case "state":
        return value.trim() === "" ? "Please enter state name" : "";
      default:
        return "";
    }
  };

  const validateContact = (field, value) => {
    switch (field) {
      case "name":
        return value.trim() === "" ? "Please enter contact person name" : "";
      case "email":
        return value.trim() === ""
          ? "Please enter email"
          : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? "Please enter a valid email"
          : "";
      case "mobile":
        return value.trim() === ""
          ? "Please enter mobile number"
          : !/^\d{10}$/.test(value)
          ? "Please enter a valid mobile number"
          : "";

      case "website":
        return value.trim() !== "" &&
          !/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)?$/.test(value)
          ? "Please enetr a valid website url"
          : "";

      default:
        break;
    }
  };
  const handleContactChange = (field, value) => {
    setContact((prevContact) => ({
      ...prevContact,
      [field]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      contact: {
        ...prevErrors.contact,
        [field]: validateContact(field, value),
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };
    let sanitizedcheckoutTime = standardPrice;
    let sanitizedavailableRooms = availableRooms;

    switch (name) {
      case "name":
        setName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter valid property name"
            : "";
        break;

      case "propertyType":
        setpropertyType(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select property type" : "";
        break;

      case "starRating":
        setstarRating(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select star rating" : "";
        break;

      case "locality":
        setLocality(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select locality" : "";
        break;

      case "standardPrice":
        sanitizedcheckoutTime = value.replace(/\D/g, "").slice(0, 6);
        setstandardPrice(sanitizedcheckoutTime);
        validationErrors[name] =
          sanitizedcheckoutTime === "" ||
          !priceRegex.test(sanitizedcheckoutTime)
            ? "Please enter valid price"
            : "";
        break;

      case "availableRooms":
        sanitizedavailableRooms = value.replace(/\D/g, "").slice(0, 3);
        setavailableRooms(sanitizedavailableRooms);
        validationErrors[name] =
          sanitizedavailableRooms === "" ||
          !priceRegex.test(sanitizedavailableRooms)
            ? "Please enter valid value"
            : "";
        break;

      case "description":
        setDescription(value);
        if (errors.description && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const scrollToError = () => {
    const firstErrorField = document.querySelector(".is-invalid");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstErrorField.focus();
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!name?.trim()) {
      newErrors.name = "Please enter property name";
    } else if (!nameregex.test(name)) {
      newErrors.name = "Please enter valid property name";
    }
    if (!starRating) {
      newErrors.starRating = "Please select a star rating";
    }

    if (!propertyType) {
      newErrors.propertyType = "Please select property type";
    }

    if (selectedAmenities.length === 0) {
      newErrors.amenities = "Please select at least one amenity";
    }
    if (!locality) {
      newErrors.locality = "Please select locality";
    }

    if (!standardPrice) {
      newErrors.standardPrice = "Please enter standard price";
    } else if (!priceRegex.test(standardPrice)) {
      newErrors.standardPrice = "Please enter valid price";
    }

    if (!availableRooms) {
      newErrors.availableRooms = "Please enter available rooms";
    } else if (!priceRegex.test(availableRooms)) {
      newErrors.availableRooms = "Please enter valid value";
    }

    if (!description?.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    if (!bookingPolicy?.trim() || stripHtmlTags(bookingPolicy).length === 0) {
      newErrors.bookingPolicy = "Please enter valid booking policy";
    }

    if (images.length === 0) {
      newErrors.image = "Please upload at least one image";
    }

    console.log("Validation errors:", newErrors);
    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;

    // If form is invalid, scroll to the first error
    if (!isValid) {
      scrollToError();
    }

    return isValid;
  };
  const addPackage = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.");
      setIsDisabled(false);
      return;
    }

    const item = {
      propertyType,
      name,
      starRating,
      standardPrice,
      availableRooms,
      isActive: 1,
      amenities: selectedAmenities,
      contact,
      locality,
      bookingPolicy,
      images: images,
      description,
      id,
    };

    try {
      await dispatch(editHotel(item)).unwrap();
      alert("Property edited successfully!");
      navigate("/admin/property");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (images.length + files.length > 15) {
      setImageError("You can upload a maximum 15 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image"
        );
        return;
      }
    }

    setImages((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  useEffect(() => {
    console.log("Updated images state:", images);
  }, [images]);

  const removeImage = (index) => {
    setImages((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Start typing...",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const propertyData = await dispatch(getpropertyType()).unwrap();
        setpropertytypeList(propertyData?.propertyTypeData || []);

        const placeData = await dispatch(getPlaceList()).unwrap();
        setplaceList(placeData?.placesData || []);

        const amenityDatas = await dispatch(getAmenityList()).unwrap();
        setamenityList(amenityDatas?.amenityData || []);
      } catch (err) {
        console.error("Error fetching data:", err.message);
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Property</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/property"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Property
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Property</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Property Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  maxLength={150}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Property Name"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>
              <div className="col-md-5">
                <label className="form-label">
                  Property Type <span className="text-danger">*</span>
                </label>
                <select
                  name="propertyType"
                  value={propertyType}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.propertyType ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  {propertytypeList?.map((catdata) => (
                    <option key={catdata._id} value={catdata._id}>
                      {catdata.name}
                    </option>
                  ))}
                </select>
                {errors.propertyType && (
                  <div className="text-danger mt-2">{errors.propertyType}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Standard Price <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="standardPrice"
                  value={standardPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.standardPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Standard Price"
                />
                {errors.standardPrice && (
                  <div className="text-danger mt-2">{errors.standardPrice}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Available Rooms
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="availableRooms"
                  value={availableRooms}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.availableRooms ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Available Rooms"
                />
                {errors.availableRooms && (
                  <div className="text-danger mt-2">
                    {errors.availableRooms}
                  </div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Locality<span className="text-danger">*</span>
                </label>
                <select
                  name="locality"
                  value={locality}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.locality ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  {placeList?.map((placedata) => (
                    <option key={placedata._id} value={placedata._id}>
                      {placedata.name}
                    </option>
                  ))}
                </select>

                {errors.locality && (
                  <div className="text-danger mt-2">{errors.locality}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Star Rating<span className="text-danger">*</span>
                </label>
                <select
                  name="starRating"
                  value={starRating}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.starRating ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  <option value="No Rating">No Rating</option>
                  <option value="2 Star">2 Star</option>
                  <option value="3 Star">3 Star</option>
                  <option value="4 Star">4 Star</option>
                  <option value="5 Star">5 Star</option>
                </select>

                {errors.starRating && (
                  <div className="text-danger mt-2">{errors.starRating}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label for="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {images.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  onChange={(newContent) => {
                    setDescription(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid description"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Select Amenities <span className="text-danger">*</span>
                </label>
                <div
                  className="border p-3 d-flex flex-wrap gap-3"
                  style={{ borderRadius: "5px" }}
                >
                  {amenityList.map((amenity) => (
                    <div key={amenity._id} className="form-check">
                      <input
                        type="checkbox"
                        style={{ marginTop: "4px" }}
                        id={`amenity-${amenity._id}`}
                        value={amenity._id}
                        checked={selectedAmenities.includes(amenity._id)}
                        onChange={() => handleAmenityChange(amenity._id)}
                        className="form-check-input"
                      />
                      &nbsp;
                      <label
                        htmlFor={`amenity-${amenity._id}`}
                        className="form-check-label"
                      >
                        {amenity.name}
                      </label>
                    </div>
                  ))}
                </div>
                {errors.amenities && (
                  <div className="text-danger mt-2">{errors.amenities}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Contact Details <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  <div className="container border p-3 mb-3 rounded">
                    <div className="row mt-3">
                      {/* Name */}
                      <div className="col-md-6">
                        <label className="form-label">
                          Contact Person Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter contact person name"
                          value={contact.name}
                          onChange={(e) =>
                            handleContactChange("name", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.name ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.name && (
                          <div className="text-danger">
                            {errors.contact.name}
                          </div>
                        )}
                      </div>

                      {/* Email */}
                      <div className="col-md-6">
                        <label className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          placeholder="Enter email"
                          value={contact.email}
                          onChange={(e) =>
                            handleContactChange("email", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.email ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.email && (
                          <div className="text-danger">
                            {errors.contact.email}
                          </div>
                        )}
                      </div>

                      {/* Mobile */}
                      <div className="col-md-6 mt-3">
                        <label className="form-label">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter mobile number"
                          value={contact.mobile}
                          onChange={(e) =>
                            handleContactChange("mobile", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.mobile ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.mobile && (
                          <div className="text-danger">
                            {errors.contact.mobile}
                          </div>
                        )}
                      </div>

                      {/* Website */}
                      <div className="col-md-6 mt-3">
                        <label className="form-label">Website</label>
                        <input
                          type="text"
                          placeholder="Enter website"
                          value={contact.website}
                          onChange={(e) =>
                            handleContactChange("website", e.target.value)
                          }
                          className={`form-control ${
                            errors?.contact?.website ? "is-invalid" : ""
                          }`}
                        />
                        {errors?.contact?.website && (
                          <div className="text-danger">
                            {errors.contact.website}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Booking Policy <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={bookingPolicy}
                  onChange={(newContent) => {
                    setbookingPolicy(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      bookingPolicy:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid booking policy"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.bookingPolicy && (
                  <div className="text-danger mt-2">{errors.bookingPolicy}</div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditProperty;
